import { AlertsCard } from "@/components/dashboard/AlertsCard";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function Alerts() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">Predictive Alerts</h1>
        <p className="text-muted-foreground">
          AI-powered insights and warnings about your finances
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <AlertsCard />
        <Card className="hover:shadow-lg transition-all duration-200 border-0 shadow-md">
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <span>⚙️</span>
              <span>Alert Settings</span>
            </CardTitle>
            <CardDescription>
              Configure your notification preferences
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-center text-muted-foreground py-12">
              <div className="text-4xl mb-4">🔔</div>
              <p>Alert configuration coming soon</p>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {['Budget Tracking', 'Spending Patterns', 'Goal Monitoring'].map((title, i) => (
          <Card key={i} className="hover:shadow-lg transition-all duration-200 border-0 shadow-md">
            <CardHeader>
              <CardTitle>{title}</CardTitle>
              <CardDescription>
                AI insights for {title.toLowerCase()}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-center text-muted-foreground py-8">
                <div className="text-2xl mb-2">🤖</div>
                <p className="text-sm">{title} alerts coming soon</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}